import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LanguageSelector from './LanguageSelector'

export default function Header() {
  const { t } = useTranslation()
  return (
    <header className="absolute top-0 left-0 right-0 z-20">
      <div className="container-custom pt-2 pb-3 md:py-6 flex items-center justify-between">
        <Link to="/" className="inline-flex items-center">
          <div className="relative w-14 h-14 lg:w-16 lg:h-16 overflow-hidden">
            <img
              alt="NEST"
              className="absolute inset-0 w-full h-full object-contain brightness-0 invert"
              loading="lazy"
              src="/images/logo.png"
            />
          </div>
          <span className="text-white/40 text-lg lg:text-xl font-light -ml-2">|</span>
          <span className="text-white/80 text-base lg:text-lg uppercase tracking-wider font-light ml-1">
            {t('header.pay')}
          </span>
        </Link>
        <LanguageSelector />
      </div>
    </header>
  )
}
